// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7858 ? "cb52ea26" : chunkId) + "." + {"6583":"7e0d38057b1cf1e5","7858":"d761c2fcde36af21","8769":"4f8334920abdad76"}[chunkId] + ".js";
};